import React from 'react';
import { Modal, ModalProps } from '@vimily/bonjoro-ui-components-v2/Modal';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';

export interface CloseWarningModalProps extends ModalProps {
  onLeaveClick?: () => void;
}

export const CloseWarningModal = ({
  onLeaveClick,
  ...modalProps
}: CloseWarningModalProps) => {
  return (
    <Modal
      {...modalProps}
      hideCloseButton
      className='sm:!w-[475px] rounded-md !inset-px !p-0'
      overlayClassName='!z-[9999999999]'
      closeButtonClassName='!top-7.5 !right-7.5 text-[30px]'
    >
      <div className='flex flex-col gap-y-8 items-center justify-center text-center p-[1.625rem]'>
        <i className='icon icon-error !v2-bg-red-700 !w-[50px] !h-[50px]' />
        <span className='text-[21px] font-bold flex flex-col gap-y-2'>
          <span>Are you sure you want to leave?</span>
          <span>Any videos will not be saved or sent.</span>
        </span>
        <div className='flex flex-col gap-y-4'>
          <div className='flex flex-row gap-x-5 justify-center'>
            <Button
              onClick={modalProps?.onModalClose}
              variant={ButtonVariant.Secondary}
              className='!py-2'
            >
              Cancel
            </Button>
            <Button
              onClick={onLeaveClick}
              variant={ButtonVariant.Danger}
              className='!py-2'
            >
              Leave and discard
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
